import { render, staticRenderFns } from "./examList.vue?vue&type=template&id=827dbb48&scoped=true"
import script from "./examList.vue?vue&type=script&lang=js"
export * from "./examList.vue?vue&type=script&lang=js"
import style0 from "./examList.vue?vue&type=style&index=0&id=827dbb48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827dbb48",
  null
  
)

export default component.exports